let lastOverlayTrigger = null;
const syncOverlayState = () => {
  const hasOpenOverlay = Boolean(document.querySelector(".overlay:not([hidden])"));
  document.body.classList.toggle("has-open-overlay", hasOpenOverlay);
  document.querySelectorAll('main, #shopify-section-footer, #shopify-section-announcement-bar, .skip-link').forEach(element => {
    if (hasOpenOverlay && !element.inert) {
      element.inert = true;
      element.dataset.overlayInert = 'true';
    } else if (!hasOpenOverlay && element.dataset.overlayInert) {
      element.inert = false;
      delete element.dataset.overlayInert;
    }
  });
  document.querySelectorAll('[data-open]').forEach(trigger => {
    const panel = document.getElementById(trigger.dataset.open);
    if (!panel) return;
    trigger.setAttribute('aria-controls', panel.id);
    trigger.setAttribute('aria-expanded', String(!panel.hidden));
  });
};
syncOverlayState();
matchMedia('(min-width: 990px)').addEventListener('change', event => {
  const menu = document.getElementById('mobile-menu');
  if (!event.matches || !menu || menu.hidden) return;
  menu.hidden = true;
  syncOverlayState();
  document.querySelector('.header__logo')?.focus({preventScroll:true});
});

document.addEventListener("click", (event) => {
  const opener = event.target.closest("[data-open]");
  if (opener) {
    const target = document.getElementById(opener.dataset.open);
    if (target) {
      lastOverlayTrigger = opener;
      document.querySelectorAll('.overlay').forEach(panel => { panel.hidden = panel !== target; });
      target.hidden = false;
      syncOverlayState();
      if (target.id === "search-overlay") {
        requestAnimationFrame(() => {
          const input = target.querySelector('input[type="search"]');
          if (input) input.focus({ preventScroll: true });
        });
      } else {
        target.querySelector('[data-close]')?.focus({ preventScroll: true });
      }
    }
    return;
  }

  const closer = event.target.closest("[data-close]");
  if (closer) {
    const target = document.getElementById(closer.dataset.close);
    if (target) {
      target.hidden = true;
      syncOverlayState();
      lastOverlayTrigger?.focus({ preventScroll: true });
    }
    return;
  }

  const accordion = event.target.closest(".accordion__btn");
  if (accordion) {
    const body = accordion.nextElementSibling;
    if (body) {
      body.hidden = !body.hidden;
      accordion.setAttribute('aria-expanded', String(!body.hidden));
      const indicator = accordion.querySelector('span');
      if (indicator) indicator.textContent = body.hidden ? '+' : '−';
    }
    return;
  }

  /* Butoanele +/- de cantitate (pagina de produs). Delegat aici ca sa mearga
     indiferent de sectiune, fara sa depinda de scriptul inline al produsului. */
  const qty = event.target.closest("[data-qty]");
  if (qty) {
    const form = qty.closest("form");
    const input = form && form.querySelector("[name='quantity']");
    if (input) {
      const minimum = Number(input.min || 1);
      const maximum = input.max ? Number(input.max) : Infinity;
      const step = Number(input.step || 1);
      input.value = Math.min(maximum, Math.max(minimum, (Number(input.value) || minimum) + Number(qty.dataset.qty) * step));
      input.dispatchEvent(new Event('change', {bubbles:true}));
    }
    return;
  }

  const thumb = event.target.closest("[data-thumb]");
  if (thumb) {
    const gallery = thumb.closest("[data-gallery]");
    const main = gallery.querySelector("[data-gallery-main]");
    if (!main) return;
    main.srcset = thumb.dataset.thumbSrcset || '';
    main.src = thumb.dataset.thumb;
    main.dataset.zoomSrc = thumb.dataset.thumb;
    gallery.querySelectorAll("[data-thumb]").forEach((b) => b.setAttribute("aria-current", String(b === thumb)));
  }
});

/* Escape inchide orice overlay deschis (cautare, meniu mobil) */
document.addEventListener("keydown", (event) => {
  const overlay = document.querySelector('.overlay:not([hidden])');
  if (event.key === 'Tab' && overlay) {
    const elements = Array.from(overlay.querySelectorAll('a[href],button:not([disabled]),input:not([disabled]):not([type="hidden"]),select,textarea,[tabindex="0"]')).filter(el => el.getClientRects().length);
    const first = elements[0];
    const last = elements[elements.length - 1];
    if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last?.focus(); }
    else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first?.focus(); }
  }
  if (event.key !== "Escape" || !overlay) return;
  document.querySelectorAll(".overlay:not([hidden])").forEach((el) => {
    el.hidden = true;
  });
  syncOverlayState();
  lastOverlayTrigger?.focus({ preventScroll: true });
});

/* Logica de variante si pret de pe pagina de produs traieste in
   sections/main-product.liquid (scriptul inline de acolo). Blocul vechi de
   aici facea aceeasi treaba a doua oara, cu texte in engleza si pretul
   formatat gresit ("199.00" in loc de "199 lei") pentru o clipa, pana il
   suprascria cel corect. Scos complet — un singur proprietar al logicii. */

/* Sorting / filtering on collection pages */
document.querySelectorAll("[data-url-select]").forEach((select) => {
  select.addEventListener("change", () => {
    window.location.href = select.value;
  });
});

/* Category fan carousel */
document.querySelectorAll("[data-fan]").forEach((root) => {
  const cards = Array.from(root.querySelectorAll("[data-fan-card]"));
  const dots = Array.from(root.querySelectorAll("[data-fan-dot]"));
  const nameEl = root.querySelector("[data-fan-name]");
  const labels = cards.map((card) => card.querySelector(".fan__label strong")?.textContent.trim() ?? "");
  const offsets = [
    { x: 0, y: 0, r: 0, s: 1, z: 10 },
    { x: 11.25, y: 1.3, r: 10, s: 0.9346, z: 3 },
    { x: 16.5, y: 4, r: 14, s: 0.8498, z: 2 },
    { x: 22.5, y: 7.3, r: 21, s: 0.7756, z: 1 },
  ];
  const total = cards.length;
  if (!total) return;
  let active = 0;

  /* Offseturile sunt in rem si erau fixe, deci pe telefon cardurile exterioare
     ieseau complet din ecran. Le strangem proportional pe ecrane mici. */
  const spread = () => {
    if (window.innerWidth >= 768) return 1;
    const cardWidth = cards[0].offsetWidth;
    return Math.max(.4, Math.min(.62, (root.clientWidth - 24 - cardWidth * .95) / 360));
  };

  const render = () => {
    cards.forEach((card, index) => {
      let d = ((index - active) % total + total) % total;
      if (d > total / 2) d -= total;
      const abs = Math.abs(d);
      /* La numar par de carduri, cardul diametral opus nu are pereche pe
         cealalta parte, asa ca evantaiul iesea stramb (2 dreapta, 1 stanga).
         Il ascundem, ca aripile sa ramana simetrice la orice numar de carduri. */
      const antipodal = total % 2 === 0 && abs === total / 2;
      const hidden = antipodal || abs >= offsets.length;
      const o = offsets[Math.min(abs, offsets.length - 1)];
      const sign = Math.sign(d);
      const k = spread();
      const transform =
        "translate(" + o.x * sign * k + "rem, " + o.y * k + "rem) rotate(" + o.r * sign + "deg) scale(" + (hidden ? 0.3 : o.s) + ")";

      /* Cardul care trece dintr-o aripa in cealalta face ocolul intregului
         evantai. Cu tranzitia pornita se vedea cum traverseaza prin fata
         celorlalte — asta era "glitch"-ul de la schimbarea ordinii. Il asezam
         instantaneu in noua pozitie si il aducem din opacitate, ca sa apara
         pe margine, nu sa zboare prin mijloc. */
      const prev = card.__fanD;
      const first = prev === undefined;
      const wrapped = !first && Math.abs(d - prev) > total / 2;
      card.__fanD = d;

      if (first || wrapped) {
        card.style.transition = "none";
        card.style.transform = transform;
        card.style.opacity = wrapped || hidden ? 0 : 1;
        card.style.zIndex = hidden ? 0 : o.z;
        void card.offsetWidth; /* comitem stilul cat tranzitia e taiata */
        card.style.transition = "";
      } else {
        card.style.transform = transform;
        card.style.zIndex = hidden ? 0 : o.z;
      }

      card.style.opacity = hidden ? 0 : 1;
      card.style.pointerEvents = hidden ? "none" : "auto";
      const link = card.querySelector(".fan__link");
      if (link) link.tabIndex = index === active ? 0 : -1;
    });
    dots.forEach((dot, index) => dot.setAttribute("aria-current", String(index === active)));
    if (nameEl) nameEl.textContent = labels[active];
  };

  const go = (dir) => {
    /* dublul modulo tine indexul valid si cand dir e mai mare decat numarul
       de carduri (o tragere lunga poate cere mai multi pasi deodata) */
    active = (((active + dir) % total) + total) % total;
    render();
  };

  root.querySelector("[data-fan-prev]")?.addEventListener("click", () => go(-1));
  root.querySelector("[data-fan-next]")?.addEventListener("click", () => go(1));
  dots.forEach((dot, index) =>
    dot.addEventListener("click", () => {
      active = index;
      render();
    }),
  );
  cards.forEach((card, index) =>
    card.addEventListener("click", (event) => {
      if (index !== active) {
        event.preventDefault();
        active = index;
        render();
      }
    }),
  );

  /* ---- Slide / swipe pe evantai -------------------------------------------
     Evantaiul se schimba si prin tragere cu degetul (mobil) sau cu mouse-ul
     (desktop), nu doar din sageti si buline. Regulile:
       - tragere orizontala = schimba cardul; tragere verticala = scroll normal
         al paginii (decidem directia dupa primii ~8px de miscare);
       - blocul NU se translateaza sub deget. Singurul lucru care se misca e
         ORDINEA cardurilor: la fiecare STEP px trasi, evantaiul avanseaza cu
         un card, chiar in timpul tragerii, cu aceeasi animatie ca la sageti.
         O tragere lunga trece deci prin mai multe carduri;
       - daca s-a tras, clickul de la final e anulat, ca sa nu deschida colectia
         fara voie la ridicarea degetului.                                     */
  const stage = root.querySelector(".fan") || root;
  const STEP = 60; /* px de tras pentru fiecare card avansat */
  const AXIS_LOCK = 8; /* px dupa care decidem: orizontal sau vertical */
  const AXIS_BIAS = 1.35; /* e un carusel: la egalitate preferam orizontala */
  const MIN_GAP = 80; /* ms intre doi pasi, ca sa nu se suprapuna animatiile */
  let lastStep = 0;
  let pointerId = null;
  let startX = 0;
  let startY = 0;
  let anchorX = 0; /* de unde se masoara urmatorul pas */
  let moved = false;
  let dragging = false;
  let decided = false;
  /* Fereastra in care clickul de dupa o tragere e ignorat. Daca ar fi un simplu
     boolean ar ramane agatat cand tragerea nu produce niciun click (swipe) si
     ar manca tapul urmator — deci expira singur. */
  let swallowUntil = 0;

  /* O SINGURA regula pentru axa, folosita si de pointer, si de touch. Daca
     fiecare ar decide dupa pragul lui, s-ar putea contrazice pe un gest oblic:
     touch-ul ar taia scrollul, pointerul ar abandona tragerea si degetul n-ar
     mai face nimic — nici scroll, nici schimbare de card. */
  const axisOf = (dx, dy) => {
    if (Math.abs(dx) < AXIS_LOCK && Math.abs(dy) < AXIS_LOCK) return null;
    return Math.abs(dy) > Math.abs(dx) * AXIS_BIAS ? "y" : "x";
  };

  const reset = () => {
    dragging = false;
    decided = false;
    pointerId = null;
    stage.classList.remove("is-dragging");
  };

  const onDown = (event) => {
    if (event.pointerType === "mouse" && event.button !== 0) return;
    if (event.target.closest(".fan__controls")) return;
    swallowUntil = 0;
    pointerId = event.pointerId;
    startX = event.clientX;
    startY = event.clientY;
    anchorX = event.clientX;
    moved = false;
    dragging = true;
    decided = false;
    document.addEventListener("pointermove", onMove, { passive: false });
    document.addEventListener("pointerup", onUp);
    document.addEventListener("pointercancel", onCancel);
  };

  const onMove = (event) => {
    if (!dragging || event.pointerId !== pointerId) return;
    const ax = event.clientX - startX;
    const ay = event.clientY - startY;

    if (!decided) {
      const axis = axisOf(ax, ay);
      if (!axis) return;
      if (axis === "y") {
        /* vertical: lasam pagina sa scrolleze, nu mai luam noi evenimentele */
        detach();
        reset();
        return;
      }
      decided = true;
      /* ancora ramane punctul de start, nu locul in care s-a decis axa —
         altfel primii ~10px de miscare s-ar pierde si primul card ar cere
         mai mult de STEP px ca sa se schimbe */
      anchorX = startX;
      stage.classList.add("is-dragging");
    }

    moved = true;
    if (event.cancelable) event.preventDefault();

    const delta = event.clientX - anchorX;
    if (Math.abs(delta) < STEP) return;
    /* Pasii trebuie sa se vada unul cate unul. Fara pauza asta, la o tragere
       rapida trei pasi plecau in ~30ms, toate cardurile porneau odata si
       evantaiul se stangea o clipa intr-o parte — parea rupt. */
    const now = Date.now();
    if (now - lastStep < MIN_GAP) return;
    lastStep = now;
    /* MAXIM un card pe eveniment. La un flick, un singur `pointermove` poate
       aduce 300px deodata; daca am aplica toti pasii dintr-o data, evantaiul
       ar face ture complete si ar cadea inapoi pe cardul de start — exact
       sariturile de ordine. Ancora se muta la degetul curent, deci si
       schimbarea de directie se simte imediat. */
    anchorX = event.clientX;
    go(delta < 0 ? 1 : -1); /* tras spre stanga = cardul urmator */
  };

  const onUp = () => {
    const dragged = decided && moved;
    detach();
    reset();
    if (dragged) swallowUntil = Date.now() + 400;
  };

  const onCancel = () => {
    detach();
    reset();
  };

  function detach() {
    document.removeEventListener("pointermove", onMove, { passive: false });
    document.removeEventListener("pointerup", onUp);
    document.removeEventListener("pointercancel", onCancel);
  }

  root.addEventListener("pointerdown", onDown);
  /* imaginile sunt draggable nativ in browser si ar bloca tragerea cu mouse-ul */
  root.addEventListener("dragstart", (event) => event.preventDefault());
  /* clickul de dupa o tragere nu trebuie sa deschida colectia */
  root.addEventListener(
    "click",
    (event) => {
      if (Date.now() > swallowUntil) return;
      swallowUntil = 0;
      event.preventDefault();
      event.stopPropagation();
    },
    true,
  );

  /* ---- Taierea scrollului pe telefon --------------------------------------
     La Pointer Events, preventDefault pe pointermove NU opreste scrollul:
     browserul se ia dupa `touch-action` si dupa raspunsul la touchmove-uri.
     Asa ca axa o taiem cu handlere de touch dedicate, non-passive: la primul
     touchmove decidem directia (aceeasi regula ca la pointer) si, daca e
     orizontala, chemam preventDefault pe FIECARE touchmove pana se ridica
     degetul — browserul nu mai porneste scrollul deloc. Asta ajunge: browserul
     asteapta sincron raspunsul nostru exact pe touchmove-ul care iese din
     toleranta lui de miscare, deci decizia vine mereu la timp, si la
     swipe-urile date repede unul dupa altul.

     Aici NU se mai umbla la `touch-action` din JS. Am avut o clasa care punea
     `touch-action: none` cat tinea swipe-ul, dar touch-action se citeste O
     SINGURA DATA, la inceputul gestului: clasa inca activa cand incepea gestul
     urmator facea un swipe vertical dat imediat dupa unul orizontal complet
     MORT — browserul nu mai scrolla (gestul pornise cu touch-action: none),
     iar noi il clasificam vertical si nu-l lua nici evantaiul. */
  let touchAxis = null;
  let touchX = 0;
  let touchY = 0;

  root.addEventListener(
    "touchstart",
    (event) => {
      if (event.touches.length !== 1 || event.target.closest(".fan__controls")) {
        touchAxis = "y"; /* pinch sau tap pe sageti/buline: nu ne bagam */
        return;
      }
      touchAxis = null;
      touchX = event.touches[0].clientX;
      touchY = event.touches[0].clientY;
    },
    { passive: true },
  );

  root.addEventListener(
    "touchmove",
    (event) => {
      if (touchAxis === "y" || event.touches.length !== 1) return;

      if (touchAxis === null) {
        const axis = axisOf(event.touches[0].clientX - touchX, event.touches[0].clientY - touchY);
        if (!axis) return;
        touchAxis = axis;
        if (axis === "y") return; /* scroll normal al paginii */
      }

      if (event.cancelable) event.preventDefault();
    },
    { passive: false },
  );

  const onTouchEnd = (event) => {
    /* Resetam abia cand s-au ridicat TOATE degetele. La multi-touch, touchend
       vine pentru fiecare deget in parte, iar un reset prematur ar lasa
       touchmove-urile ramase sa re-decida axa dintr-un punct de start vechi. */
    if (event.touches.length === 0) touchAxis = null;
  };

  root.addEventListener("touchend", onTouchEnd, { passive: true });
  root.addEventListener("touchcancel", onTouchEnd, { passive: true });

  window.addEventListener("resize", render);
  render();
});

